import React from "react";

import { ButtonLinkStyled } from "../../../../components/common/Buttons/Button.Style";

import PhoneImage from "../../../../assets/images/empresarial/phone.png";

import * as S from "./ActivateInsuranceSection.style";

const ActivateInsuranceSection = () => {
  return (
    <S.ActivateInsuranceSectionContainer>
      <S.ActivateInsuranceSectionTitle className="container">
        Como acionar o seguro?
      </S.ActivateInsuranceSectionTitle>

      <S.ActivateInsuranceSectionContent className="container">
        <S.ActivateInsuranceSectionImage
          src={PhoneImage}
          alt="ilustração de um smartphone visto em perspectiva, apoiado em uma base"
          width="170px"
          height="170px"
        />

        <S.ActivateInsuranceSectionBlock>
          <S.ActivateInsuranceSectionBlockDescription>
            Para acionar as coberturas do seu Seguro ou solicitar um serviço de
            assistência, ligue para o nosso telefone ou converse com um de
            nossos atendentes pelo WhatsApp.
          </S.ActivateInsuranceSectionBlockDescription>

          <ButtonLinkStyled type="button" className="phone-number">
            0800 274 1000
          </ButtonLinkStyled>
        </S.ActivateInsuranceSectionBlock>
      </S.ActivateInsuranceSectionContent>
    </S.ActivateInsuranceSectionContainer>
  );
};

export default ActivateInsuranceSection;
